import { hubbleAPI } from './url'
const resource = hubbleAPI + 'public/ct/keep-subscription'
export default ($axios) => ({
  /**
   *
   * @param productKey
   * @param sku
   * @param cartID the cart id used
   * @param accessToken a json object {
   *       userName: 'userName',
   *       password: 'a password',
   *       accessTokenType: 'UN_PW'
   *     }
   *     Access token is required to be of type UN_PW
   * @returns {*}
   */
  getKeepSubscriptionDiscount(productKey, sku, cartID, accessToken) {
    const config = { headers: { 'Content-Type': 'application/json' } }
    return $axios.post(`${resource}/calculate/discounts/${productKey}/${sku}/${cartID}`, accessToken, config)
  },
  validateKeepSubscriptionDiscount(cartID) {
    return $axios.get(`${resource}/validate/discount/${cartID}`)
  }

})
